
import { useEffect, useRef, useState } from 'react';
import Hero from './components/Hero';
import Wildlife from './components/Wildlife';
import Activities from './components/Activities';
import VisitorInfo from './components/VisitorInfo';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-gradient-to-b from-sky-50 to-white">
      <Navigation isScrolled={isScrolled} />
      <Hero />
      <Wildlife />
      <Activities />
      <VisitorInfo />
      <Footer />
    </div>
  );
}
